var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.75H5M6.5 11.75H5M11 5.75H5M14 8.375V5.6C14 4.33988 14 3.70982 13.7548 3.22852C13.539 2.80516 13.1948 2.46095 12.7715 2.24524C12.2902 2 11.6601 2 10.4 2H5.6C4.33988 2 3.70982 2 3.22852 2.24524C2.80516 2.46095 2.46095 2.80516 2.24524 3.22852C2 3.70982 2 4.33988 2 5.6V13.4C2 14.6601 2 15.2902 2.24524 15.7715C2.46095 16.1948 2.80516 16.539 3.22852 16.7548C3.70982 17 4.33988 17 5.6 17H7.625M15.5 17L14.375 15.875M15.125 14C15.125 15.4497 13.9497 16.625 12.5 16.625C11.0503 16.625 9.875 15.4497 9.875 14C9.875 12.5503 11.0503 11.375 12.5 11.375C13.9497 11.375 15.125 12.5503 15.125 14Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSearch);
export default __webpack_public_path__ + "static/media/document_search.7f87070af4eab48683c31c2c36d940e8.svg";
export { ForwardRef as ReactComponent };